<script lang="ts" setup>
import { ObSpace, ObModal } from '../../components';
import { UiButton } from '../../components/ui-button';
import { ConfirmDialog } from './shared';
import { useConfirmDialog } from './use-confirm-dialog';
interface Props {
  dialog: ConfirmDialog;
}
const props = defineProps<Props>();
const { remove } = useConfirmDialog();
function cancel() {
  props.dialog.onCancel?.(props.dialog);
  remove(props.dialog.id);
}
function confirm() {
  props.dialog.onConfirm?.(props.dialog);
  remove(props.dialog.id);
}
</script>

<template>
  <ObModal
    active
    style="width: 480px"
    :title="props.dialog.title"
    :deactivate-on-overlay-click="false"
    :close-button="false"
    :on-before-deactivate="() => false"
  >
    <div :class="$style.body">
      <div class="text-body-1">
        <component :is="props.dialog.contentComponent" v-if="props.dialog.contentComponent" />
        <template v-else>{{ props.dialog.text }}</template>
      </div>
      <div :class="$style.spacer" />
      <ObSpace :class="$style.actions" spacing="4">
        <UiButton variant="secondary" size="l" @click="cancel()">
          {{ props.dialog.cancelText }}
        </UiButton>
        <UiButton size="l" @click="confirm()">{{ props.dialog.confirmText }}</UiButton>
      </ObSpace>
    </div>
  </ObModal>
</template>

<style lang="scss" module>
.body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.spacer {
  flex: 1;
  min-height: 24px;
}

.actions {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
}

.actions :global([data-ui-component='UiButton']) {
  width: 100%;
}
</style>
